import apiClient from 'api/common/common'
import { MyPageResponse } from 'api/common/responses'
import { Status } from 'api/common/statuses'
import { AxiosResponse } from 'axios'
import loginData from '../utilities/loginData'

/**
 * マイページAPI
 * @param request
 * @param callback
 */
const myPageAPI = async (callback: (status: Status, result: MyPageResponse) => void) => {
  await apiClient.get('/myPage').then((response: AxiosResponse<MyPageResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    const result = status === Status.Success
    if (result) {
      loginData.setContractStatus(response.data.contractStatus)
      loginData.setRegistrationStatus(response.data.registrationStatus)
      loginData.setUserType(response.data.userType)
    }
    callback(status, response.data)
  })
}

export default myPageAPI
